import React from "react";

const DEFAULT_SIZES = "(max-width: 768px) 84px, 200px";

const buildSrcSet = (imageVariants) =>
  imageVariants.map(({ src, width }) => `${src} ${width}w`).join(", ");

/**
 * Selects the smallest useful landing-category image for the browser's
 * supported format, viewport, and device pixel ratio.
 */
const ResponsiveCategoryImage = ({
  sources,
  alt,
  className,
  sizes = DEFAULT_SIZES,
  loading = "eager",
}) => {
  const fallback =
    sources.webp.find(({ width }) => width === 400) || sources.webp[0];

  return (
    <picture>
      <source
        type="image/avif"
        srcSet={buildSrcSet(sources.avif)}
        sizes={sizes}
      />
      <source
        type="image/webp"
        srcSet={buildSrcSet(sources.webp)}
        sizes={sizes}
      />
      <img
        className={className}
        src={fallback.src}
        srcSet={buildSrcSet(sources.webp)}
        sizes={sizes}
        width="200"
        height="133"
        alt={alt}
        loading={loading}
        decoding="async"
      />
    </picture>
  );
};

export default ResponsiveCategoryImage;
